import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { initialAppState } from "../common/reducers/appState";
import ReturnToLandingPageButton from "../components/ReturnToLandingPageButton";
import { All } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  return {
    currentApp: appState.app,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: (app: string) => {
      dispatch(actions.resetState((initialAppState as any)[app]));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReturnToLandingPageButton);
